

export const stripTags = input => input.replace(/<[^>]*>/g, ' ').trim()
